import { ADICIONAR_FILTRO_AGENCIA } from '../types'

export default function adicionarFiltroAgencia (filtro) {
  return {
    type: ADICIONAR_FILTRO_AGENCIA,
    payload: filtro
  }
}
